<template>
    <div class="card">
        <div class="bg-blue-light p-1">
            <TitleButton 
                :showBtn="false"
                title="Process Tracker"
            />
        </div>

         <section id="basic-tabs-components">
        <div class="row match-height">
          <div class="col-12">
            <div class="card">
              <div class="card-body">
                <div>
                  <div class="row">

                    <div class="col-12 col-sm-6 col-md-3 col-lg-3  mb-1">
                      <div class="mb-1">
                        <label for="colFormLabel" class="col-form-label">Type</label>
                        <v-select
                            placeholder="Select Type"
                            v-model="processTracker"
                            :options="processTrackerList"
                            :reduce="name => name.value"
                            label="name"
                        />
                      </div>
                    </div>

                    <div class="col-12 col-sm-6 col-md-3 col-lg-2  mb-1">
                      <div class="mb-1">
                        <label for="colFormLabel" class="col-form-label">Start Date</label>
                        <vField
                            v-model="startDate"
                            name="date"
                            id="date"
                            type="date"
                            class="form-control"
                        />
                      </div>
                    </div>

                    <div v-if="isIpdService" class="col-12 col-sm-6 col-md-2 col-lg-2 mb-1">
                      <div class="mb-1">
                        <label class="col-form-label">Start Time</label>
                        <vField
                            v-model="startTime"
                            name="start_time"
                            type="time"
                            class="form-control"
                        />
                      </div>
                    </div>

                    <div class="col-12 col-sm-6 col-md-3 col-lg-2  mb-1">
                      <div class="mb-1">
                        <label for="colFormLabel" class="col-form-label">End Date</label>
                        <vField
                            v-model="endDate"
                            name="date"
                            id="date"
                            type="date"
                            class="form-control"
                        />
                      </div>
                    </div>

                    <div v-if="processTracker === 'bill_process'" class="col-12 col-sm-6 col-md-3 col-lg-2  mb-1">
                      <div class="mb-1">
                        <label for="colFormLabel" class="col-form-label">Due Date</label>
                        <vField
                            v-model="dueDate"
                            name="due_date"
                            id="due_date"
                            type="datetime-local"
                            class="form-control"
                            :min="today"
                        />
                      </div>
                    </div>

                    <div v-if="isIpdService" class="col-12 col-sm-6 col-md-2 col-lg-2 mb-1">
                      <div class="mb-1">
                        <label class="col-form-label">End Time</label>
                        <vField
                            v-model="endTime"
                            name="end_time"
                            type="time"
                            class="form-control"
                        />
                      </div>
                    </div>

                    <template v-if="isIpdService">
                      <div class="col-12 col-sm-6 col-md-2 col-lg-2 mb-1">
                        <div class="mb-1">
                          <label class="col-form-label">Grace Period Start</label>
                          <vField
                              v-model="gracePeriodStartTime"
                              name="grace_period_start_time"
                              type="time"
                              class="form-control"
                          />
                        </div>
                      </div>

                      <div class="col-12 col-sm-6 col-md-2 col-lg-2 mb-1">
                        <div class="mb-1">
                          <label class="col-form-label">Grace Period End</label>
                          <vField
                              v-model="gracePeriodEndTime"
                              name="grace_period_end_time"
                              type="time"
                              class="form-control"
                          />
                        </div>
                      </div>
                    </template>

                    <div class="col-12 col-sm-6 col-md-1 col-lg-1 mb-1">
                      <button
                          style="min-width: 64px; margin-top: 2.5rem"
                          @click="onClickToGo"
                          class="btn btn-primary btn-block waves-effect waves-float waves-light"
                      > Process
                      </button>
                    </div>
                  </div>
                  <div class="card" style="min-height: 400px">
                    <div class="col-12 mt-2 mb-4">
                      <div class="table-responsive">
                        <table class="table table-bordered">
                          <thead>
                          <tr>
                            <th class="text-center">Process Type</th>
                            <th class="text-center">Start Date</th>
                            <th class="text-center">End Date</th>
                            <th class="text-center">Status</th>
                            <th class="text-center">Action</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr v-for="(item, i) in tableItems" :key="i">
                            <td class="text-center text-capitalize">{{ item.type }}</td>
                            <td class="text-center">{{ item.start_date }}</td>
                            <td class="text-center">{{ item.end_date }}</td>
                            <td class="text-center text-capitalize">{{ item.status }}</td>
                            <td class="text-center">
                              <button
                                v-if="item.type === 'ipd_service'"
                                @click="onClickReprocess(item)"
                                class="btn btn-sm btn-warning waves-effect waves-float waves-light"
                              >Reprocess</button>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                        <p v-if="tableItems.length < 0" class="text-center mt-5">No data</p>
                      </div>
                    </div>
                  </div>

                  <div class="px-2 pt-2 position-absolute bottom-0 mt-4">
                    <Pagination :offset="params.offset" @onPageChange="onPageChange" ref="pagination"/>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Loader v-if="loading"/>

    </div>
</template>

<script setup>
import TitleButton from '@/components/atom/TitleButton';
import {inject, onMounted, reactive, ref, watch, computed} from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import Loader from '@/components/atom/LoaderComponent'
import handleHrPayroll from "@/services/modules/hrPayroll/hrPayroll";
import useDate from "@/services/utils/day";
import Pagination from '@/components/atom/Pagination'

const store = useStore();
const route = useRoute();
const router = useRouter();
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const startDate = ref('')
const endDate = ref('')
const { endOfTodayForInput } = useDate();
const dueDate = ref(endOfTodayForInput())
const loading = ref(false)
const token = computed(() => localStorage.getItem('token'));
const params = ref({
  offset: 20,
});
const tableItems = ref([]);
const processTrackerList = ref([]);
const processTracker = ref('')
const startTime = ref('')
const endTime = ref('')
const gracePeriodStartTime = ref('')
const gracePeriodEndTime = ref('')
const additionalProductQuery = { product_type: 'services' }

const isIpdService = computed(() => processTracker.value === 'ipd_service')

const {
  fetchTypes,
  createProcessTracker,
  fetchProcessTrackerData,
  reprocessIpdService,
} = handleHrPayroll()

const setPaginationData = (data) => {
  store.commit('setPaginationData', data)
};

const onPageChange = async (page) => {
  let routeQuery = Object.assign({}, route.query)
  routeQuery.page = page
  await router.push({path: route.path, query: routeQuery})
  await getProcessList();
}

const setPagination = (data) => {
  setPaginationData({
    records: data.total,
    perPage: data.per_page,
    currentPage: data.current_page,
  })
}

const getProcessList = async () => {
  let query =`?company_id=${route.params.companyId}`;
  if (route.query.page) query += '&page=' + route.query.page;
  query += '&offset=' + params.value.offset
  loading.value = true
  tableItems.value = [];

  await fetchProcessTrackerData(query).then(res => {
    if (!res.status){
      store.commit("resetPagination")
      return
    }
    tableItems.value = res.data.data
    setPagination(res.data)
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

const getTypes = async () => {
  let query =`?company_id=${route.params.companyId}`;
  await fetchTypes(query).then(res => {
    if (!res.status){
      processTrackerList.value = [];
      return
    }

    const data = res.data || {};
    processTrackerList.value = data.processTracker || [];
  }).catch(err => {
    console.log(err)
  })
}

const getQuery = () => {
  let query = `?company_id=${route.params.companyId}`;
  if (startDate.value) query += '&start_date=' + startDate.value;
  if (endDate.value) query += '&end_date=' + endDate.value;
  if (processTracker.value === 'bill_process' && dueDate.value) {
      const formattedDate = dueDate.value.replace('T', ' ');
      query += '&due_date=' + formattedDate;
  }
  if (processTracker.value) query += '&type=' + processTracker.value;
  if (isIpdService.value && startTime.value) query += '&start_time=' + startTime.value;
  if (isIpdService.value && endTime.value) query += '&end_time=' + endTime.value;
  if (isIpdService.value && gracePeriodStartTime.value) query += '&grace_period_start_time=' + gracePeriodStartTime.value;
  if (isIpdService.value && gracePeriodEndTime.value) query += '&grace_period_end_time=' + gracePeriodEndTime.value;
  return query;
}

const onClickReprocess = async (item) => {
  if (!confirm('Are you sure you want to reprocess? All previously generated bills will be deleted and regenerated.')) {
    return
  }
  const query = `?company_id=${route.params.companyId}&process_tracker_id=${item.id}`
  loading.value = true
  await reprocessIpdService(query).then(res => {
    if (!res.status) {
      showError(res.message)
      return
    }
    showSuccess(res.message)
    getProcessList()
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

const buildMissingMessage = (items) => {
  const names = items.map(item => item.service_name).filter(Boolean)
  const list = names.length ? names.join(', ') : 'some services'
  return `The following services have no product mapped and will be skipped: ${list}. Do you want to continue?`
}

const runProcess = async (query) => {
  loading.value = true
  await createProcessTracker(query).then(res => {
    if (res.needs_confirmation) {
      handleNeedsConfirmation(query, res.data)
      return
    }
    if (!res.status){
      showError(res.message)
      return
    }
    showSuccess(res.message)
    getProcessList();
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

const handleNeedsConfirmation = (query, items) => {
  loading.value = false
  if (!confirm(buildMissingMessage(items))) return
  runProcess(query + '&confirmed=1')
}

const onClickToGo = async () => {
  await runProcess(getQuery())
}

onMounted(() => {
  Promise.all([
      getTypes(),
      getProcessList(),
  ])
})

</script>

<style scoped>
.head td {
  text-align: right;
}
</style>